export const categories = [
  {
    slug: 'saishi-zhibo',
    name: '赛事直播',
    description: '高清流畅的体育赛事直播App，覆盖足球、篮球、网球等热门赛事',
    icon: 'ri-live-line',
    color: 'accent',
  },
  {
    slug: 'yundong-jilu',
    name: '运动记录',
    description: '精准记录跑步、骑行、健身等运动数据，科学管理你的运动生活',
    icon: 'ri-run-line',
    color: 'secondary',
  },
  {
    slug: 'jingcai-hudong',
    name: '竞猜互动',
    description: '体育竞猜、社区互动、赛事讨论，与千万球迷一起畅聊体育',
    icon: 'ri-fire-line',
    color: 'accent',
  },
  {
    slug: 'tiyu-zixun',
    name: '体育资讯',
    description: '最新最全的体育新闻、深度分析、独家报道，随时随地掌握体坛动态',
    icon: 'ri-newspaper-line',
    color: 'secondary',
  },
];

export const apps = [
  {
    id: 1,
    name: '腾讯体育',
    icon: 'https://readdy.ai/api/search-image?query=Tencent%20Sports%20app%20icon%20design%20minimalist%20blue%20gradient%20circle%20shape%20clean%20modern%20simple%20background&width=200&height=200&seq=app-icon-tencent-sports&orientation=squarish',
    category: 'saishi-zhibo',
    rating: 4.6,
    downloads: '2.3亿+',
    description: 'NBA、英超、中超等顶级赛事直播，专业解说团队，多机位高清画质，支持回放与集锦功能',
    features: ['多联赛直播', '1080P高清', '赛事回放', '数据统计', '社区互动'],
    price: '免费（含内购）',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 1,
  },
  {
    id: 2,
    name: '咪咕视频',
    icon: 'https://readdy.ai/api/search-image?query=Migu%20Video%20sports%20app%20icon%20design%20orange%20gradient%20modern%20circle%20shape%20clean%20simple&width=200&height=200&seq=app-icon-migu-video&orientation=squarish',
    category: 'saishi-zhibo',
    rating: 4.5,
    downloads: '1.8亿+',
    description: 'CBA、五大联赛、奥运会等大型赛事独家版权，4K超清直播体验，专业体育内容聚合平台',
    features: ['4K超清', '独家版权', '多屏互动', '赛事预约', 'VR观赛'],
    price: '免费（含会员）',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 1,
  },
  {
    id: 3,
    name: 'Keep',
    icon: 'https://readdy.ai/api/search-image?query=Keep%20fitness%20app%20icon%20design%20green%20gradient%20modern%20circle%20shape%20clean%20minimalist%20simple%20background&width=200&height=200&seq=app-icon-keep&orientation=squarish',
    category: 'yundong-jilu',
    rating: 4.8,
    downloads: '3.1亿+',
    description: '全民运动健身平台，提供跑步、骑行、瑜伽等数百种运动课程，智能训练计划，记录每一次进步',
    features: ['智能训练', '运动记录', '课程教学', '饮食管理', '社区打卡'],
    price: '免费（含会员）',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 2,
  },
  {
    id: 4,
    name: '咕咚',
    icon: 'https://readdy.ai/api/search-image?query=Codoon%20sports%20app%20icon%20design%20red%20gradient%20circle%20shape%20modern%20clean%20simple%20background&width=200&height=200&seq=app-icon-gudong&orientation=squarish',
    category: 'yundong-jilu',
    rating: 4.4,
    downloads: '1.5亿+',
    description: '专业跑步骑行运动记录工具，GPS精准定位，丰富赛事活动，智能装备连接，科学训练指导',
    features: ['GPS定位', '赛事活动', '装备连接', '训练计划', '运动社交'],
    price: '免费（含内购）',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 2,
  },
  {
    id: 5,
    name: '懂球帝',
    icon: 'https://readdy.ai/api/search-image?query=Dongqiudi%20football%20app%20icon%20design%20dark%20green%20gradient%20circle%20shape%20modern%20clean%20simple%20background&width=200&height=200&seq=app-icon-dongqiudi&orientation=squarish',
    category: 'jingcai-hudong',
    rating: 4.5,
    downloads: '1.2亿+',
    description: '足球迷的专属社区，实时比分、赛事数据、转会新闻、深度战术分析，足球竞猜互动乐趣无穷',
    features: ['实时比分', '足球数据', '转会新闻', '竞猜互动', '球迷社区'],
    price: '免费（含内购）',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 3,
  },
  {
    id: 6,
    name: '虎扑',
    icon: 'https://readdy.ai/api/search-image?query=Hupu%20sports%20community%20app%20icon%20design%20red%20gradient%20circle%20shape%20modern%20clean%20simple%20background&width=200&height=200&seq=app-icon-hupu&orientation=squarish',
    category: 'jingcai-hudong',
    rating: 4.3,
    downloads: '2.0亿+',
    description: '国内最大的体育社区平台，NBA、CBA、足球等多种体育话题讨论，专业评分体系和装备鉴定服务',
    features: ['体育社区', '装备鉴定', '赛事讨论', '步行街', '评分系统'],
    price: '免费',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 4,
  },
  {
    id: 7,
    name: '直播吧',
    icon: 'https://readdy.ai/api/search-image?query=Zhibo8%20sports%20live%20app%20icon%20design%20blue%20gradient%20circle%20shape%20modern%20clean%20simple%20background&width=200&height=200&seq=app-icon-zhibo8&orientation=squarish',
    category: 'saishi-zhibo',
    rating: 4.2,
    downloads: '1.0亿+',
    description: '全面的体育赛事信息平台，提供足球、篮球等赛事直播源聚合，赛程赛果一手掌握',
    features: ['直播聚合', '赛程赛果', '视频集锦', '数据统计', '新闻资讯'],
    price: '免费',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 1,
  },
  {
    id: 8,
    name: '悦跑圈',
    icon: 'https://readdy.ai/api/search-image?query=Happy%20Run%20running%20app%20icon%20design%20yellow%20gradient%20circle%20shape%20modern%20clean%20simple%20background&width=200&height=200&seq=app-icon-yuepaoquan&orientation=squarish',
    category: 'yundong-jilu',
    rating: 4.3,
    downloads: '8000万+',
    description: '跑步爱好者的社交平台，线上马拉松、跑步挑战赛、跑团活动，让跑步不再孤单',
    features: ['线上马拉松', '跑步挑战', '跑团社交', '数据记录', '勋章系统'],
    price: '免费（含会员）',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 2,
  },
  {
    id: 9,
    name: '企鹅体育',
    icon: 'https://readdy.ai/api/search-image?query=Penguin%20Sports%20live%20app%20icon%20design%20cyan%20blue%20gradient%20circle%20shape%20modern%20clean%20simple%20background&width=200&height=200&seq=app-icon-qie-sports&orientation=squarish',
    category: 'saishi-zhibo',
    rating: 4.1,
    downloads: '6000万+',
    description: '腾讯旗下体育直播平台，NBA、中超等赛事直播，专业解说和丰富互动体验',
    features: ['NBA直播', '中超直播', '专业解说', '互动弹幕', '赛事数据'],
    price: '免费（含会员）',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 1,
  },
  {
    id: 10,
    name: '每日瑜伽',
    icon: 'https://readdy.ai/api/search-image?query=Daily%20Yoga%20fitness%20app%20icon%20design%20purple%20gradient%20circle%20shape%20modern%20clean%20simple%20background&width=200&height=200&seq=app-icon-daily-yoga&orientation=squarish',
    category: 'yundong-jilu',
    rating: 4.6,
    downloads: '7000万+',
    description: '专业的瑜伽健身App，海量瑜伽课程、冥想引导、体式精讲，在家也能系统练习瑜伽',
    features: ['瑜伽课程', '冥想引导', '体式精讲', '训练计划', '社区交流'],
    price: '免费（含会员）',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 2,
  },
  {
    id: 11,
    name: 'PP体育',
    icon: 'https://readdy.ai/api/search-image?query=PP%20Sports%20live%20app%20icon%20design%20dark%20blue%20gradient%20circle%20shape%20modern%20clean%20simple%20background&width=200&height=200&seq=app-icon-pp-sports&orientation=squarish',
    category: 'saishi-zhibo',
    rating: 4.4,
    downloads: '1.6亿+',
    description: '苏宁旗下体育直播平台，拥有五大联赛、中超、亚冠等顶级赛事版权，专业解说与数据分析',
    features: ['五大联赛', '中超亚冠', '数据分析', '多视角', '回放功能'],
    price: '免费（含会员）',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 1,
  },
  {
    id: 12,
    name: '体育疯',
    icon: 'https://readdy.ai/api/search-image?query=Sports%20news%20app%20icon%20design%20orange%20red%20gradient%20circle%20shape%20modern%20clean%20simple%20background&width=200&height=200&seq=app-icon-tiyufeng&orientation=squarish',
    category: 'tiyu-zixun',
    rating: 4.0,
    downloads: '4500万+',
    description: '体育资讯聚合平台，实时推送足球、篮球、网球等各类体育新闻，深度分析文章和专业评论',
    features: ['实时推送', '深度分析', '视频新闻', '专栏作者', '个性化推荐'],
    price: '免费',
    platform: ['iOS', 'Android'],
    downloadUrl: '#',
    articleId: 4,
  },
];

export const articles = [
  {
    id: 1,
    slug: 'tiyu-zhibo-app-duibi-2024',
    title: '2024年最值得下载的5款体育直播App深度对比',
    excerpt: '从画质、解说、赛事版权和用户体验等维度，横向对比腾讯体育、咪咕视频、直播吧、PP体育、企鹅体育五大体育直播App',
    content: `近年来，体育赛事直播App市场竞争日益激烈。对于球迷来说，选择一款适合自己的体育直播App至关重要。本文将从赛事版权、画质体验、解说团队、功能特色和价格五个维度，深度对比2024年最值得关注的5款体育直播App。

## 腾讯体育

腾讯体育依托腾讯强大的平台资源，拥有NBA、英超、中超等顶级赛事版权。其自主研发的直播技术确保了1080P高清流畅的观赛体验。专业解说团队包括多位前国手和资深体育评论员。此外，腾讯体育还整合了社区互动、赛事数据和短视频内容，打造了一站式体育内容平台。

**优势**：赛事版权丰富，画质优秀，互动体验好
**不足**：部分重要赛事需要会员付费观看

## 咪咕视频

作为中国移动旗下的视频平台，咪咕视频在体育版权方面投入巨大。拥有CBA、五大联赛、奥运会等重磅赛事独家版权。4K超清画质是咪咕的核心竞争力之一，同时支持VR观赛和多屏互动。

**优势**：4K超清画质，独家版权多，VR观赛
**不足**：部分内容仅限移动用户

## 直播吧

直播吧以其丰富全面的赛事信息著称，提供足球、篮球、网球等多个项目的直播源聚合服务。界面简洁直观，赛程赛果一目了然。免费模式下也能获得不错的观赛体验。

**优势**：赛事信息全面，免费内容多，使用门槛低
**不足**：画质相对一般，解说资源有限

## PP体育

苏宁旗下的PP体育拥有五大联赛、中超、亚冠等重量级版权。专业的数据分析系统和多视角观看模式是PP体育的差异化优势。其智能推荐算法能根据用户偏好推送个性化内容。

**优势**：版权顶级，数据专业，多视角观看
**不足**：会员价格偏高

## 企鹅体育

企鹅体育主打NBA和中超赛事直播，背靠腾讯的内容生态。其互动弹幕功能深受年轻用户喜爱，让观赛变得更加有趣。赛事数据实时更新，帮助球迷深度了解比赛。

**优势**：NBA直播体验佳，互动功能丰富
**不足**：赛事版权相对集中

## 综合推荐

对于追求极致画质的用户，推荐咪咕视频；对于想要一站式体验的球迷，腾讯体育是不错的选择；如果注重性价比，直播吧免费内容充足。建议根据自己的观赛偏好和预算做出选择。`,
    category: 'saishi-zhibo',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20sports%20live%20streaming%20comparison%20concept%20with%20multiple%20smartphone%20screens%20displaying%20different%20sports%20apps%20on%20a%20clean%20minimalist%20desk%20with%20warm%20ambient%20lighting%20editorial%20photography%20style%20high%20detail&width=1200&height=630&seq=article-cover-live-compare&orientation=landscape',
    author: '体育App指南编辑部',
    date: '2024-08-01',
    readTime: '8分钟',
    tags: ['体育直播', 'App对比', '观赛指南'],
  },
  {
    id: 2,
    slug: 'paobu-aiche-app-tuijian',
    title: '跑步爱好者必备：2024年最佳运动记录App推荐',
    excerpt: '无论是入门跑者还是马拉松爱好者，这几款运动记录App都能帮助你科学训练、持续进步',
    content: `跑步已经成为最受欢迎的全民运动之一。一款好的运动记录App不仅能记录跑步数据，更能帮助你制定科学的训练计划。以下是2024年最值得使用的运动记录App推荐。

## Keep

Keep不只是跑步记录工具，更是一个综合性的运动健身平台。它提供了从入门到进阶的完整跑步训练体系，配合语音指导和音乐伴跑功能，让每一次跑步都充满动力。

**核心功能**：
- GPS跑步记录，精准追踪配速、距离、卡路里
- 法特莱克跑、间歇跑等多种专业训练模式
- 丰富的线下跑步活动和线上挑战赛
- 智能训练计划，根据你的数据调整强度

## 咕咚

作为国内最早的运动App之一，咕咚在跑步领域有着深厚的积累。其GPS算法经过多年优化，定位精度在业内处于领先水平。智能装备连接功能支持主流运动手表和心率带。

**核心功能**：
- 高精度GPS定位与轨迹记录
- 线上线下赛事活动丰富
- 智能装备无缝连接
- 跑步训练课程和计划

## 悦跑圈

悦跑圈是一款专注于跑步社交的运动App。它独创的线上马拉松模式让跑者足不出户也能参与马拉松赛事。丰富的勋章系统和跑团功能激发了用户的跑步热情。

**核心功能**：
- 线上马拉松，随时随地参赛
- 跑团社交，找到志同道合的跑友
- 丰富的勋章激励系统
- 跑步数据深度分析

## 如何选择

如果你是跑步初学者，Keep的综合训练体系最适合你；如果你追求数据精准和专业训练，咕咚是不错的选择；如果你喜欢社交互动，悦跑圈的社区氛围最棒。建议下载试用后再做决定。`,
    category: 'yundong-jilu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20person%20running%20on%20a%20scenic%20trail%20at%20sunrise%20with%20a%20smartphone%20on%20the%20arm%20showing%20fitness%20tracking%20app%20interface%20minimalist%20style%20warm%20golden%20light%20clean%20composition&width=1200&height=630&seq=article-cover-running-apps&orientation=landscape',
    author: '体育App指南编辑部',
    date: '2024-07-28',
    readTime: '6分钟',
    tags: ['跑步', '运动记录', '健身App'],
  },
  {
    id: 3,
    slug: 'zuqiu-mi-bibe-app',
    title: '足球迷的手机必装App清单：从看球到聊球全覆盖',
    excerpt: '真正的足球迷手机里都装了哪些App？从赛事直播到深度分析，这份清单帮你打造完美的足球内容生态',
    content: `足球是世界第一运动，对于真正的球迷来说，手机里必须装对App才能不错过任何精彩。本文为你梳理足球迷必备的App清单。

## 看球必备：赛事直播App

**腾讯体育**：NBA和英超球迷的首选，高清画质加上专业解说，观赛体验一流。社区功能让球迷可以边看球边讨论。

**咪咕视频**：五大联赛和CBA的版权大户，4K画质是最大亮点。如果你追求极致的视觉体验，咪咕是最佳选择。

## 聊球必备：社区互动App

**懂球帝**：足球领域的垂直社区，从五大联赛到中超，从战术分析到转会传闻，应有尽有。其竞猜功能让看球更有参与感。

**虎扑**：虽然不止足球，但虎扑的足球板块活跃度极高。专业评分体系和深度讨论氛围，是资深球迷的聚集地。

## 数据必备：专业分析App

**SofaScore**（国际）：虽然本文主要推荐国内App，但SofaScore的实时数据覆盖范围和数据维度都是顶级的，值得每一位数据型球迷安装。

## 推荐组合

看球用腾讯体育或咪咕，聊球用懂球帝或虎扑，数据用SofaScore。三件套配齐，你就是最in的球迷！`,
    category: 'jingcai-hudong',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20passionate%20football%20fan%20watching%20match%20on%20smartphone%20in%20a%20modern%20living%20room%20with%20football%20memorabilia%20warm%20ambient%20lighting%20clean%20minimalist%20interior%20editorial%20style&width=1200&height=630&seq=article-cover-football-fan&orientation=landscape',
    author: '体育App指南编辑部',
    date: '2024-07-25',
    readTime: '5分钟',
    tags: ['足球', '球迷', 'App推荐'],
  },
  {
    id: 4,
    slug: 'tiyu-zixun-app-pingce',
    title: '体育资讯App哪家强？2024年主流平台横向测评',
    excerpt: '面对众多体育资讯App，如何选择最适合自己的？我们从内容质量、更新速度和用户体验三大维度进行全面测评',
    content: `体育资讯是球迷日常获取信息的重要渠道。一款好的体育资讯App应该具备内容全面、更新及时、阅读体验好等特点。以下是2024年主流体育资讯App的横向测评。

## 懂球帝

懂球帝以足球内容为核心，兼顾其他体育项目。其编辑团队的专业性在同类App中较为突出，深度分析文章质量高。但内容覆盖面相对集中，非足球迷可能会觉得内容不够丰富。

**评分**：内容质量 4.5/5，更新速度 4.3/5，用户体验 4.2/5

## 虎扑

虎扑的资讯涵盖NBA、CBA、足球等多个项目，UGC内容占比高，讨论氛围浓厚。步行街等特色板块增加了用户粘性。但信息噪音较大，需要用户自行筛选。

**评分**：内容质量 4.1/5，更新速度 4.5/5，用户体验 4.0/5

## 体育疯

体育疯专注于体育新闻聚合，通过算法推荐个性化内容。视频新闻占比较高，适合喜欢短视频形式的用户。但原创深度内容相对不足。

**评分**：内容质量 3.8/5，更新速度 4.4/5，用户体验 4.3/5

## 综合建议

如果你主看足球，懂球帝是最佳选择；如果想要多元化的社区讨论，虎扑更合适；如果喜欢短视频形式获取资讯，体育疯值得一试。`,
    category: 'tiyu-zixun',
    coverImage: 'https://readdy.ai/api/search-image?query=Multiple%20smartphones%20displaying%20different%20sports%20news%20app%20interfaces%20on%20a%20clean%20white%20marble%20desk%20with%20a%20cup%20of%20coffee%20modern%20minimalist%20workspace%20bright%20natural%20lighting&width=1200&height=630&seq=article-cover-news-review&orientation=landscape',
    author: '体育App指南编辑部',
    date: '2024-07-20',
    readTime: '7分钟',
    tags: ['体育资讯', 'App测评', '新闻App'],
  },
  {
    id: 5,
    slug: 'NBA-guansai-app-zhongji',
    title: 'NBA球迷观赛App终极指南：从直播到数据分析',
    excerpt: 'NBA球迷如何打造完美的观赛体验？我们为你盘点从直播到数据分析的全套App方案',
    content: `NBA是全球最受欢迎的篮球联赛，中国拥有庞大的NBA球迷群体。如何通过手机获得最佳的NBA观赛体验？本文为你详细解读。

## 直播观看

**腾讯体育**：NBA中国数字媒体独家版权方，提供全赛季直播。多机位选择、1080P画质、专业解说团队，是目前国内NBA直播的最佳选择。

**企鹅体育**：腾讯系的NBA直播补充平台，有时会提供不同的解说视角和互动玩法。

## 数据追踪

对于数据型球迷，实时的技术统计和进阶数据是深入理解比赛的关键。目前国内App的数据功能还在完善中，部分国际App提供更全面的NBA数据分析。

## 社区讨论

**虎扑**：NBA板块是虎扑最活跃的社区之一。赛后讨论、球员评分、交易流言，这里有最热闹的NBA中文讨论。

**懂球帝**：虽然以足球为主，但NBA内容也在快速增长，提供了一个相对理性的讨论空间。

## 集锦回放

如果你因为工作无法观看直播，集锦和回放是弥补遗憾的好方式。腾讯体育和企鹅体育都提供全场回放和精彩集锦功能。

## 最佳组合

直播用腾讯体育，赛后讨论上虎扑，数据追踪配合国际App。三位一体，NBA观赛体验拉满！`,
    category: 'saishi-zhibo',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20basketball%20court%20with%20a%20smartphone%20showing%20NBA%20live%20streaming%20on%20the%20screen%20modern%20clean%20style%20dramatic%20lighting%20professional%20composition%20high%20contrast&width=1200&height=630&seq=article-cover-nba-guide&orientation=landscape',
    author: '体育App指南编辑部',
    date: '2024-07-15',
    readTime: '6分钟',
    tags: ['NBA', '篮球', '观赛指南'],
  },
  {
    id: 6,
    slug: 'yundong-jiankang-app-ruxuan',
    title: '从入门到精通：运动健身App选择与使用全攻略',
    excerpt: '不同运动水平的用户如何选择合适的运动健身App？本文从入门到进阶，为各类运动爱好者提供选型建议',
    content: `运动健身App市场百花齐放，但对于不同运动水平和需求的用户来说，选择思路完全不同。本文从用户分层的角度，提供选购建议。

## 入门级用户

对于刚开始运动的用户，最重要的是建立运动习惯。

**推荐App**：Keep
Keep提供了大量免费的入门级课程，从5分钟燃脂到20分钟有氧，适合零基础用户。智能训练计划能根据你的反馈调整难度，降低入门门槛。

## 进阶级用户

当你已经养成了规律运动的习惯，可能需要更专业的功能。

**推荐App**：咕咚（跑步）/ 每日瑜伽（瑜伽）
咕咚提供专业的跑步训练计划，包括间歇跑、节奏跑等进阶模式。每日瑜伽则有丰富的体式精讲和序列课程，帮助用户提升动作质量。

## 专业级用户

对于有一定训练基础、追求更专业训练体验的用户。

需要配合智能穿戴设备获取更精准的数据。此时可以选择支持多设备连接的App，如咕咚配合运动手表使用。

## 总结

选择运动App要量力而行，从初级到高级逐步升级。先养成习惯，再追求专业。最重要的是坚持运动本身，App只是辅助工具。`,
    category: 'yundong-jilu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fitness%20enthusiast%20checking%20workout%20app%20on%20phone%20in%20a%20bright%20modern%20gym%20with%20clean%20equipment%20natural%20lighting%20through%20large%20windows%20minimalist%20aesthetic%20editorial%20photography&width=1200&height=630&seq=article-cover-fitness-guide&orientation=landscape',
    author: '体育App指南编辑部',
    date: '2024-07-10',
    readTime: '7分钟',
    tags: ['运动健身', '入门指南', 'App选择'],
  },
];